export interface StudentDetails {
  studentNumber: string;
  studentId: File | null;
}
